import { getAllSiteTypes } from './getAllSiteTypes'

export const siteTypes = [getAllSiteTypes]
